module.exports = __webpack_public_path__ + "media/images/recruit/section/mv_department07-f162562c6f1ec5ee14b0f2d63930752a.jpg";